import { NatureCulture } from 'interfaces/Dvf'

const getNatureCultureName = (natureCultureToFormat: NatureCulture): string => {
  if (natureCultureToFormat === NatureCulture.TerrainsABatir) {
    return 'Terrain à bâtir'
  }

  if (natureCultureToFormat === NatureCulture.TerrainsAgrement) {
    return "Terrains d'agrément"
  }

  if (natureCultureToFormat === NatureCulture.Bois) {
    return 'Bois'
  }

  if (natureCultureToFormat === NatureCulture.FutaiesFeuillues) {
    return 'Futaies feuillues'
  }

  if (natureCultureToFormat === NatureCulture.FutaiesMixtes) {
    return 'Futaies mixtes'
  }

  if (natureCultureToFormat === NatureCulture.Oseraies) {
    return 'Oseraies'
  }

  if (natureCultureToFormat === NatureCulture.Peupleraies) {
    return 'Peupleraies'
  }

  if (natureCultureToFormat === NatureCulture.FutaiesResineuses) {
    return 'Futaies résineuses'
  }

  if (natureCultureToFormat === NatureCulture.TaillisSousFutaie) {
    return 'Taillis sous futaie'
  }

  if (natureCultureToFormat === NatureCulture.TaillisSimples) {
    return 'Taillis simples'
  }

  if (natureCultureToFormat === NatureCulture.Carrieres) {
    return 'Carrières'
  }

  if (natureCultureToFormat === NatureCulture.CheminDeFer) {
    return 'Chemin de fer'
  }

  if (natureCultureToFormat === NatureCulture.Eaux) {
    return 'Eaux'
  }

  if (natureCultureToFormat === NatureCulture.Jardins) {
    return 'Jardins'
  }

  if (natureCultureToFormat === NatureCulture.Landes) {
    return 'Landes'
  }

  if (natureCultureToFormat === NatureCulture.LandesBoisees) {
    return 'Landes boisées'
  }

  if (natureCultureToFormat === NatureCulture.Pres) {
    return 'Prés'
  }

  if (natureCultureToFormat === NatureCulture.Patures) {
    return 'Pâtures'
  }

  if (natureCultureToFormat === NatureCulture.Pacages) {
    return 'Pacages'
  }

  if (natureCultureToFormat === NatureCulture.PresEmbouche) {
    return 'Prés d’embouche'
  }

  if (natureCultureToFormat === NatureCulture.Herbages) {
    return 'Herbages'
  }

  if (natureCultureToFormat === NatureCulture.PresPlantes) {
    return 'Prés plantes'
  }

  if (natureCultureToFormat === NatureCulture.Sols) {
    return 'Sols'
  }

  if (natureCultureToFormat === NatureCulture.Terres) {
    return 'Terres'
  }

  if (natureCultureToFormat === NatureCulture.TerresPlantees) {
    return 'Terres plantées'
  }

  if (natureCultureToFormat === NatureCulture.Vergers) {
    return 'Vergers'
  }

  if (natureCultureToFormat === NatureCulture.Vignes) {
    return 'Vignes'
  }

  return `Inconnu (${natureCultureToFormat})`
}

export default getNatureCultureName
